import camelcaseKeys from 'camelcase-keys'
import type { FlowAccumulator } from '../model'

export const handleApiResponse = () => async (acc: FlowAccumulator) => {
  if (acc.error) {
    throw new Error(acc.error?.message)
  }

  if (acc.reqConfig.getRawResponse) {
    return acc.response
  }

  try {
    const body = await acc.response?.json()

    if (body) {
      const bodyCamelCaed = camelcaseKeys(body, { deep: true, exclude: [] })

      return bodyCamelCaed
    }
  } catch (e) {
    return
  }
}
